export * from './anonymousAuthenticationProvider';